// extracted by mini-css-extract-plugin
var _1 = "t2LL";
var _2 = "t2LK";
var _3 = "t2LJ";
var _4 = "t2LG";
var _5 = "t2LI";
var _6 = "t2LH";
export { _1 as "button", _2 as "footer", _3 as "input", _4 as "maintenance", _5 as "text", _6 as "title" }
